import BlogProvider from "../provider/BlogProvider"
import BlogPostCategories from "./Categories"
import BlogPosts from "./List"

export type BlogModel = {
  source: number
}

export default function Blog({ source }: BlogModel) {
 
  return (
    <BlogProvider source={source}>
      <div className="grid-x grid-margin-x">
        <div className="cell small-12 medium-8">
          <div>
            <BlogPosts />
          </div>
        </div>
        <div className="cell small-12 medium-4">
          <div>
            <BlogPostCategories />
          </div>
        </div>
      </div>
    </BlogProvider>
  )
}